$( ".text-with-image_product" ).insertAfter( $( ".product__media-slider" ) );

$( ".product-selector__submit" ).insertAfter( $( ".rc_widget__option__plans__dropdown" ) );

document.addEventListener('DOMContentLoaded', () => {
    const getActiveLabelValue = () => {
      const fieldset = document.querySelector('fieldset.product-selector__buttons:not(.hidden)');
      if (!fieldset) return null;
  
      const activeLabel = fieldset.querySelector('label.is-active');
      if (!activeLabel) return null;
  
      const variantInputWrapper = activeLabel.querySelector('.quantity__wrapper');
      if (!variantInputWrapper) return null;
  
      const displayedValueElement = variantInputWrapper.querySelector('.displayed-value');
      return displayedValueElement
        ? displayedValueElement.textContent.trim()
        : variantInputWrapper.querySelector('.quantity__input').value;
    };
  
    const setMainInputValue = (value) => {
      const form = document.querySelector('.product__form');
      if (!form) return;
  
      const mainInputWrapper = form.querySelector('.quantity__wrapper:not(.variant-input)');
      const mainInput = mainInputWrapper ? mainInputWrapper.querySelector('.quantity__input') : null;
      if (mainInput) mainInput.value = value;
    };
  
    const handleSubmitButtonClick = (event) => {
      const value = getActiveLabelValue();
      if (value !== null) {
        setMainInputValue(value);
      }
    };
  
    const init = () => {
      const form = document.querySelector('.product__form');
      if (!form) return;
  
      form.querySelectorAll('button[type="submit"]').forEach(button => {
        button.addEventListener('click', handleSubmitButtonClick);
      });
    };
  
    init();


    const updateQtyNumber = (quantityInput, qtyNumber, firstValue) => {
      const quantity = parseInt(quantityInput.value, 10);
      qtyNumber.textContent = firstValue * (isNaN(quantity) ? 0 : quantity);
    };

    document.querySelectorAll('.variant-input__info').forEach(variantInput => {
      const quantityInput = variantInput.querySelector('.quantity__input');
      const qtyNumber = variantInput.querySelector('.qty-number');
      const firstValue = parseInt(qtyNumber.getAttribute('data-qty'), 10)

      if (!quantityInput || !qtyNumber || isNaN(firstValue)) return;

      updateQtyNumber(quantityInput, qtyNumber, firstValue);

      quantityInput.addEventListener('input', () => {
        updateQtyNumber(quantityInput, qtyNumber, firstValue);
      });

      variantInput.querySelectorAll('.quantity__button').forEach(qtyButton => {
        qtyButton.addEventListener('click', () => {
          updateQtyNumber(quantityInput, qtyNumber, firstValue);
        });
      });
    });
  });